export const getCurrentDate=()=>{
    const divider="-";
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth()+1;
    const y = today.getFullYear();

    if(dd<10) {
        dd = '0'+dd;
    }

    if(mm<10) {
        mm = '0'+mm;
    }
    return y + divider + mm + divider + dd;
};